import { render } from "./StoreTips.vue?vue&type=template&id=5c16294e&scoped=true"
import script from "./StoreTips.vue?vue&type=script&lang=js"
export * from "./StoreTips.vue?vue&type=script&lang=js"

import "./StoreTips.vue?vue&type=style&index=0&id=5c16294e&scoped=true&lang=css"

import exportComponent from "E:\\GoWorkSpace2\\src\\storedisk\\storedisk\\storedisk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c16294e"]])

export default __exports__